// Permission constants. Source of truth: backend FarmVisitLatest,
// Application.Core/Constants/Permissions.cs - do not invent or rename values.
// NOTE: the backend module key is "Companys" (not "Companies").

export const PERMISSIONS = {
  Modules: {
    Configuration: "Permissions.Modules.Configuration",
    PlanManagement: "Permissions.Modules.PlanManagement",
    VisitInfo: "Permissions.Modules.VisitInfo",
    Report: "Permissions.Modules.Report",
  },
  Dashboard: {
    Menu: "Permissions.Dashboard.Menu",
    View: "Permissions.Dashboard.View",
  },
  Users: {
    Menu: "Permissions.Users.Menu",
    View: "Permissions.Users.View",
    Create: "Permissions.Users.Create",
    Edit: "Permissions.Users.Edit",
    Delete: "Permissions.Users.Delete",
    UserExcelReport: "Permissions.Users.UserExcelReport",
    UserPdfReport: "Permissions.Users.UserPdfReport",
  },
  Roles: {
    Menu: "Permissions.Roles.Menu",
    View: "Permissions.Roles.View",
    Create: "Permissions.Roles.Create",
    Edit: "Permissions.Roles.Edit",
    Delete: "Permissions.Roles.Delete",
  },
  RoleClaims: {
    Menu: "Permissions.RoleClaims.Menu",
    View: "Permissions.RoleClaims.View",
    Create: "Permissions.RoleClaims.Create",
    Edit: "Permissions.RoleClaims.Edit",
    Delete: "Permissions.RoleClaims.Delete",
  },
  Companys: {
    Menu: "Permissions.Companys.Menu",
    View: "Permissions.Companys.View",
    Create: "Permissions.Companys.Create",
    Edit: "Permissions.Companys.Edit",
    Delete: "Permissions.Companys.Delete",
    CompanyExcelReport: "Permissions.Companys.CompanyExcelReport",
    CompanyPdfReport: "Permissions.Companys.CompanyPdfReport",
  },
  Departments: {
    Menu: "Permissions.Departments.Menu",
    View: "Permissions.Departments.View",
    Create: "Permissions.Departments.Create",
    Edit: "Permissions.Departments.Edit",
    Delete: "Permissions.Departments.Delete",
  },
  Designations: {
    Menu: "Permissions.Designations.Menu",
    View: "Permissions.Designations.View",
    Create: "Permissions.Designations.Create",
    Edit: "Permissions.Designations.Edit",
    Delete: "Permissions.Designations.Delete",
  },
  EmployeeKpiSettings: {
    Menu: "Permissions.EmployeeKpiSettings.Menu",
    View: "Permissions.EmployeeKpiSettings.View",
    Create: "Permissions.EmployeeKpiSettings.Create",
    Edit: "Permissions.EmployeeKpiSettings.Edit",
    Delete: "Permissions.EmployeeKpiSettings.Delete",
  },
  Zones: {
    Menu: "Permissions.Zones.Menu",
    View: "Permissions.Zones.View",
    Create: "Permissions.Zones.Create",
    Edit: "Permissions.Zones.Edit",
    Delete: "Permissions.Zones.Delete",
    ZoneExcelReport: "Permissions.Zones.ZoneExcelReport",
    ZonePdfReport: "Permissions.Zones.ZonePdfReport",
  },
  Areas: {
    Menu: "Permissions.Areas.Menu",
    View: "Permissions.Areas.View",
    Create: "Permissions.Areas.Create",
    Edit: "Permissions.Areas.Edit",
    Delete: "Permissions.Areas.Delete",
    AreaExcelReport: "Permissions.Areas.AreaExcelReport",
    AreaPdfReport: "Permissions.Areas.AreaPdfReport",
  },
  Territories: {
    Menu: "Permissions.Territories.Menu",
    View: "Permissions.Territories.View",
    Create: "Permissions.Territories.Create",
    Edit: "Permissions.Territories.Edit",
    Delete: "Permissions.Territories.Delete",
    TerritoryExcelReport: "Permissions.Territories.TerritoryExcelReport",
    TerritoryPdfReport: "Permissions.Territories.TerritoryPdfReport",
  },
  FeedCompanies: {
    Menu: "Permissions.FeedCompanies.Menu",
    View: "Permissions.FeedCompanies.View",
    Create: "Permissions.FeedCompanies.Create",
    Edit: "Permissions.FeedCompanies.Edit",
    Delete: "Permissions.FeedCompanies.Delete",
  },
  MedicineCompanies: {
    Menu: "Permissions.MedicineCompanies.Menu",
    View: "Permissions.MedicineCompanies.View",
    Create: "Permissions.MedicineCompanies.Create",
    Edit: "Permissions.MedicineCompanies.Edit",
    Delete: "Permissions.MedicineCompanies.Delete",
  },
  FeedTypes: {
    Menu: "Permissions.FeedTypes.Menu",
    View: "Permissions.FeedTypes.View",
    Create: "Permissions.FeedTypes.Create",
    Edit: "Permissions.FeedTypes.Edit",
    Delete: "Permissions.FeedTypes.Delete",
    FeedTypeExcelReport: "Permissions.FeedTypes.FeedTypeExcelReport",
    FeedTypePdfReport: "Permissions.FeedTypes.FeedTypePdfReport",
  },
  FarmCategories: {
    Menu: "Permissions.FarmCategories.Menu",
    View: "Permissions.FarmCategories.View",
    Create: "Permissions.FarmCategories.Create",
    Edit: "Permissions.FarmCategories.Edit",
    Delete: "Permissions.FarmCategories.Delete",
  },
  FarmTypes: {
    Menu: "Permissions.FarmTypes.Menu",
    View: "Permissions.FarmTypes.View",
    Create: "Permissions.FarmTypes.Create",
    Edit: "Permissions.FarmTypes.Edit",
    Delete: "Permissions.FarmTypes.Delete",
  },
  StrainOrBreeds: {
    Menu: "Permissions.StrainOrBreeds.Menu",
    View: "Permissions.StrainOrBreeds.View",
    Create: "Permissions.StrainOrBreeds.Create",
    Edit: "Permissions.StrainOrBreeds.Edit",
    Delete: "Permissions.StrainOrBreeds.Delete",
  },
  BusinessRelations: {
    Menu: "Permissions.BusinessRelations.Menu",
    View: "Permissions.BusinessRelations.View",
    Create: "Permissions.BusinessRelations.Create",
    Edit: "Permissions.BusinessRelations.Edit",
    Delete: "Permissions.BusinessRelations.Delete",
  },
  CustomerTypes: {
    Menu: "Permissions.CustomerTypes.Menu",
    View: "Permissions.CustomerTypes.View",
    Create: "Permissions.CustomerTypes.Create",
    Edit: "Permissions.CustomerTypes.Edit",
    Delete: "Permissions.CustomerTypes.Delete",
  },
  Customers: {
    Menu: "Permissions.Customers.Menu",
    View: "Permissions.Customers.View",
    Create: "Permissions.Customers.Create",
    Edit: "Permissions.Customers.Edit",
    Delete: "Permissions.Customers.Delete",
    CustomerExcelReport: "Permissions.Customers.CustomerExcelReport",
    CustomerPdfReport: "Permissions.Customers.CustomerPdfReport",
  },
  Ponds: {
    Menu: "Permissions.Ponds.Menu",
    View: "Permissions.Ponds.View",
    Create: "Permissions.Ponds.Create",
    Edit: "Permissions.Ponds.Edit",
    Delete: "Permissions.Ponds.Delete",
    PondExcelReport: "Permissions.Ponds.PondExcelReport",
    PondPdfReport: "Permissions.Ponds.PondPdfReport",
  },
  FishSpecies: {
    Menu: "Permissions.FishSpecies.Menu",
    View: "Permissions.FishSpecies.View",
    Create: "Permissions.FishSpecies.Create",
    Edit: "Permissions.FishSpecies.Edit",
    Delete: "Permissions.FishSpecies.Delete",
    FishSpeciesExcelReport: "Permissions.FishSpecies.FishSpeciesExcelReport",
    FishSpeciesPdfReport: "Permissions.FishSpecies.FishSpeciesPdfReport",
  },
  WaterColour: {
    Menu: "Permissions.WaterColour.Menu",
    View: "Permissions.WaterColour.View",
    Create: "Permissions.WaterColour.Create",
    Edit: "Permissions.WaterColour.Edit",
    Delete: "Permissions.WaterColour.Delete",
    WaterColourExcelReport: "Permissions.WaterColour.WaterColourExcelReport",
    WaterColourPdfReport: "Permissions.WaterColour.WaterColourPdfReport",
  },
  TentativeDiagnosis: {
    Menu: "Permissions.TentativeDiagnosis.Menu",
    View: "Permissions.TentativeDiagnosis.View",
    Create: "Permissions.TentativeDiagnosis.Create",
    Edit: "Permissions.TentativeDiagnosis.Edit",
    Delete: "Permissions.TentativeDiagnosis.Delete",
    TentativeDiagnosisExcelReport: "Permissions.TentativeDiagnosis.TentativeDiagnosisExcelReport",
    TentativeDiagnosisPdfReport: "Permissions.TentativeDiagnosis.TentativeDiagnosisPdfReport",
  },
  CoccidialStatuses: {
    Menu: "Permissions.CoccidialStatuses.Menu",
    View: "Permissions.CoccidialStatuses.View",
    Create: "Permissions.CoccidialStatuses.Create",
    Edit: "Permissions.CoccidialStatuses.Edit",
    Delete: "Permissions.CoccidialStatuses.Delete",
    CoccidialStatusExcelReport: "Permissions.CoccidialStatuses.CoccidialStatusExcelReport",
    CoccidialStatusPdfReport: "Permissions.CoccidialStatuses.CoccidialStatusPdfReport",
  },
  LitterConditions: {
    Menu: "Permissions.LitterConditions.Menu",
    View: "Permissions.LitterConditions.View",
    Create: "Permissions.LitterConditions.Create",
    Edit: "Permissions.LitterConditions.Edit",
    Delete: "Permissions.LitterConditions.Delete",
    LitterConditionExcelReport: "Permissions.LitterConditions.LitterConditionExcelReport",
    LitterConditionPdfReport: "Permissions.LitterConditions.LitterConditionPdfReport",
  },
  FarmManagementConditions: {
    Menu: "Permissions.FarmManagementConditions.Menu",
    View: "Permissions.FarmManagementConditions.View",
    Create: "Permissions.FarmManagementConditions.Create",
    Edit: "Permissions.FarmManagementConditions.Edit",
    Delete: "Permissions.FarmManagementConditions.Delete",
    FarmManagementConditionExcelReport: "Permissions.FarmManagementConditions.FarmManagementConditionExcelReport",
    FarmManagementConditionPdfReport: "Permissions.FarmManagementConditions.FarmManagementConditionPdfReport",
  },
  WorkSchedules: {
    Menu: "Permissions.WorkSchedules.Menu",
    View: "Permissions.WorkSchedules.View",
    Create: "Permissions.WorkSchedules.Create",
    Edit: "Permissions.WorkSchedules.Edit",
    Delete: "Permissions.WorkSchedules.Delete",
  },
  TourPlans: {
    Menu: "Permissions.TourPlans.Menu",
    View: "Permissions.TourPlans.View",
    Create: "Permissions.TourPlans.Create",
    Edit: "Permissions.TourPlans.Edit",
    Delete: "Permissions.TourPlans.Delete",
    TourPlanExcelReport: "Permissions.TourPlans.TourPlanExcelReport",
    TourPlanPdfReport: "Permissions.TourPlans.TourPlanPdfReport",
  },
  VisitDays: {
    Menu: "Permissions.VisitDays.Menu",
    View: "Permissions.VisitDays.View",
    Create: "Permissions.VisitDays.Create",
    Edit: "Permissions.VisitDays.Edit",
    Delete: "Permissions.VisitDays.Delete",
    VisitDayExcelReport: "Permissions.VisitDays.VisitDayExcelReport",
    VisitDayPdfReport: "Permissions.VisitDays.VisitDayPdfReport",
  },
  MonthlyPlans: {
    Menu: "Permissions.MonthlyPlans.Menu",
    View: "Permissions.MonthlyPlans.View",
    Create: "Permissions.MonthlyPlans.Create",
    Edit: "Permissions.MonthlyPlans.Edit",
    Delete: "Permissions.MonthlyPlans.Delete",
    MonthlyPlanPdfReport: "Permissions.MonthlyPlans.MonthlyPlanPdfReport",
  },
  DailyPlans: {
    Menu: "Permissions.DailyPlans.Menu",
    View: "Permissions.DailyPlans.View",
    Create: "Permissions.DailyPlans.Create",
    Edit: "Permissions.DailyPlans.Edit",
    Delete: "Permissions.DailyPlans.Delete",
    DailyPlanPdfReport: "Permissions.DailyPlans.DailyPlanPdfReport",
  },
  CustomerVisits: {
    Menu: "Permissions.CustomerVisits.Menu",
    View: "Permissions.CustomerVisits.View",
    CheckIn: "Permissions.CustomerVisits.CheckIn",
    CheckOut: "Permissions.CustomerVisits.CheckOut",
    Cancel: "Permissions.CustomerVisits.Cancel",
    Delete: "Permissions.CustomerVisits.Delete",
    CustomerVisitExcelReport: "Permissions.CustomerVisits.CustomerVisitExcelReport",
    CustomerVisitPdfReport: "Permissions.CustomerVisits.CustomerVisitPdfReport",
  },
  DealerVisits: {
    Menu: "Permissions.DealerVisits.Menu",
    View: "Permissions.DealerVisits.View",
    Create: "Permissions.DealerVisits.Create",
    Edit: "Permissions.DealerVisits.Edit",
    Delete: "Permissions.DealerVisits.Delete",
  },
  ChemistVisits: {
    Menu: "Permissions.ChemistVisits.Menu",
    View: "Permissions.ChemistVisits.View",
    Create: "Permissions.ChemistVisits.Create",
    Edit: "Permissions.ChemistVisits.Edit",
    Delete: "Permissions.ChemistVisits.Delete",
    ChemistVisitExcelReport: "Permissions.ChemistVisits.ChemistVisitExcelReport",
    ChemistVisitPdfReport: "Permissions.ChemistVisits.ChemistVisitPdfReport",
  },
  FarmVisits: {
    Menu: "Permissions.FarmVisits.Menu",
    View: "Permissions.FarmVisits.View",
    Create: "Permissions.FarmVisits.Create",
    Edit: "Permissions.FarmVisits.Edit",
    Delete: "Permissions.FarmVisits.Delete",
  },
  FishFarmVisits: {
    Menu: "Permissions.FishFarmVisits.Menu",
    View: "Permissions.FishFarmVisits.View",
    Create: "Permissions.FishFarmVisits.Create",
    Edit: "Permissions.FishFarmVisits.Edit",
    Delete: "Permissions.FishFarmVisits.Delete",
    FishFarmVisitExcelReport: "Permissions.FishFarmVisits.FishFarmVisitExcelReport",
    FishFarmVisitPdfReport: "Permissions.FishFarmVisits.FishFarmVisitPdfReport",
  },
  Attendances: {
    Menu: "Permissions.Attendances.Menu",
    View: "Permissions.Attendances.View",
    Create: "Permissions.Attendances.Create",
    Edit: "Permissions.Attendances.Edit",
    Delete: "Permissions.Attendances.Delete",
    Employee_Wise_Attendance: "Permissions.Attendances.Employee_Wise_Attendance",
    Daily_Employee_Attendance_Report:
      "Permissions.Attendances.Daily_Employee_Attendance_Report",
    Daily_Employee_Attendance_Excel_Report:
      "Permissions.Attendances.Daily_Employee_Attendance_Excel_Report",
    Employee_Attendance_Report:
      "Permissions.Attendances.Employee_Attendance_Report",
    Employee_Attendance_Excel_Report:
      "Permissions.Attendances.Employee_Attendance_Excel_Report",
    Employee_Attendance_Summary_Report:
      "Permissions.Attendances.Employee_Attendance_Summary_Report",
    Employee_Attendance_Summary_Excel_Report:
      "Permissions.Attendances.Employee_Attendance_Summary_Excel_Report",
  },
  MOWiseFarmVisit: {
    Menu: "Permissions.MOWiseFarmVisit.Menu",
    View: "Permissions.MOWiseFarmVisit.View",
  },
  FieldVisitKpi: {
    Menu: "Permissions.FieldVisitKpi.Menu",
    View: "Permissions.FieldVisitKpi.View",
  },
  DailyFieldActivity: {
    Menu: "Permissions.DailyFieldActivity.Menu",
    View: "Permissions.DailyFieldActivity.View",
  },
};
